import {
  pageInfo,
  exportData
} from './../api';
import { taskPkgAreaSelect, customerSelect } from '../../../../api'
const pointsStatistics = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    taskPkgAreaObj: null,
    customerObj: null,
    exportObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    /**
     * 大区
     * @param state
     * @param data
     * @constructor
     */
    TASK_PKG_AREA_SELECT(state, data){
      state.taskPkgAreaObj = data.obj;
    },
    /**
     * 经销商
     * @param state
     * @param data
     * @constructor
     */
    CUSTOMER_SELECT(state, data){
      state.customerObj = data.obj;
    },
    /**
     * 导出
     * @param state
     * @param data
     * @constructor
     */
    EXPORT_DATA(state, data){
      state.exportObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    /**
     * 大区
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async taskPkgAreaSelect({commit}, obj) {
      let resp = await taskPkgAreaSelect(obj);
      commit('TASK_PKG_AREA_SELECT', resp);
    },
    /**
     * 经销商
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async customerSelect({commit}, obj) {
      let resp = await customerSelect(obj);
      commit('CUSTOMER_SELECT', resp);
    },
    /**
     * 导出
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default pointsStatistics



// WEBPACK FOOTER //
// ./src/page/dataManagement/pointsStatistics/store/pointsStatistics.store.js